import { memo, useEffect, useState } from 'react';
import {Nav, NavItem, NavLink} from 'reactstrap';
import { useHistory, useLocation } from 'react-router-dom';


const Tabs = memo(({t,onTabChange, report}) => {
    const [activeTab, setActiveTab] = useState("");
    const history = useHistory();
    const location = useLocation();

    const isActiveTab = (currentTab, tab) => currentTab === tab;
    const isDeleted = report?.status === 5 ||  report?.is_deleted_content;
    const isReporterAnalystOnly = report?.is_reporter_analyst_only;
    const isNonDsrCase =
      report?.questionnaire_slug &&
      report.questionnaire_slug !== "data_subject_request";

    const tabsLinks = [
      {
        key: "request",
        title: "Request",
      },
      // {
      //   key: "data-mpping",
      //   title: "Data Mapping",
      // },
      {
        key: "lia",
        title: "LIA",
        disabled: isDeleted || isReporterAnalystOnly || isNonDsrCase
      },
      {
        key: "messages",
        title: "Messages",
        disabled: isDeleted
      },
      {
        key: "internal-comments",
        title: "Internal Comments",
        disabled: isDeleted
      },
      {
        key: "task-management",
        title: "Task Management",
        disabled: isDeleted
      },
    ];
    useEffect(() => {
        setActiveTab((new URLSearchParams(location.search)).get('tab'));
        onTabChange();
    }, [ location.search ]);

    useEffect(() => {
        if(!(new URLSearchParams(location.search)).get('tab')){
            history.push({
                search: '?tab=request',
                state: location.state,
            });
        }
    }, [location.search ]);

    return (
        <div style={{
            backgroundColor: '#D1D2D6'
        }}>
            <Nav tabs className="custom-style-1">
                {
                    tabsLinks.map((link) => {
                        return (
                            <NavItem className={isActiveTab(activeTab, link.key) ? 'active': ''} key={link.key} hidden={link?.disabled}>
                                <NavLink
                                    className={isActiveTab(activeTab, link.key) ? 'active': ''}
                                    onClick={() => history.push({
                                        search: `?tab=${link.key}`,
                                        state: location.state,
                                    })}
                                    >

                                    {t(link.title)}
                                </NavLink>
                            </NavItem>
                        )
                    })
                }
            </Nav>
        </div>
	);
});

export default Tabs;
